module.exports = __webpack_public_path__ + "static/media/correct.7e75fcc8.mp3";